module.exports = __webpack_public_path__ + "assets/map-6f1d99.svg";